import React from 'react';
import IsaAllowanceWidget from '../IsaAllowanceWidget';

/** @import { WelcomeHeaderProps } from '../../DashboardNewTypes' */

/**
 * Welcome Header component
 * Displays the welcome message and optional dashboard switcher
 * @param {WelcomeHeaderProps} props
 */
const WelcomeHeader = ({ 
    firstName, 
    featureEnabled, 
    showIsaAllowance, 
    isaAllowance,
    showIsaTooltip,
    onToggleIsaTooltip 
}) => {
    return (
        <div className="new-dashboard__header">
            <div className="new-dashboard__welcome">
                <h1 className="new-dashboard__title">Hi {firstName}</h1>
                <div className="new-dashboard__subtitle-row">
                    <h2 className="new-dashboard__subtitle">Welcome to your dashboard</h2>
                    
                    {showIsaAllowance && (
                        <IsaAllowanceWidget 
                            isaAllowance={isaAllowance}
                            showIsaTooltip={showIsaTooltip}
                            onToggleIsaTooltip={onToggleIsaTooltip}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WelcomeHeader;
